import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const langOptions = [
    { value: 'guj', label: 'Gujarati', isFixed: false },
    { value: 'eng', label: 'English', isFixed: false },
    { value: 'hin', label: 'Hindi', isFixed: false },
    { value: 'fre', label: 'French', isFixed: false },
    { value: 'ger', label: 'German', isFixed: false },
    { value: 'spa', label: 'Spanish', isFixed: false },
    { value: 'por', label: 'Portuguese', isFixed: false },
    { value: 'rus', label: 'Russian', isFixed: false },
    { value: 'chi', label: 'Mandarin', isFixed: false },
    { value: 'kor', label: 'Korean', isFixed: false },
    { value: 'kan', label: 'Kannada', isFixed: false },
];
//const GUJARATI_LANGUAGE_INDEX = 0;
const ENGLISH_LANGUAGE_INDEX = 1;
//const HINDI_LANGUAGE_INDEX = 2;
const ADMIN = 'Admin';
const VIEW_ONLY = 'View-Only';

const styles = {
    multiValue: (base, state) => {
        return state.isFixed ? { ...base, backgroundColor: 'white' } : base;
    },
    multiValueLabel: (base, state) => {
        return state.isFixed ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 } : base;
    },
    multiValueRemove: (base, state) => {
        return state.isFixed ? { ...base, display: 'none' } : base;
    },
};

function getLanguageNames(languages) {
    return languages.map((lang) => lang.label);
}

export function getLanguages(readFromVideoData, filterLanguagesBeingProcessed) {
    if (readFromVideoData) {
        // When displaying in the edit view
        const videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
        let languageNames = [];
        if (filterLanguagesBeingProcessed) {
            languageNames = videoPropsLng?.videoLanguages
                .filter((item) => item.status !== 'PROCESSING')
                .map((item) => item.languageName);
        } else {
            languageNames = videoPropsLng?.videoLanguages.map((item) => item.languageName);
        }
        return languageNames;
    } else {
        // When displaying the create video dropdown
        return langOptions.filter((item) => item.value !== 'Gujarati');
    }
}

export function getLanguagesForEditView() {
    let languagesSupported = getLanguages(true, true);

    // Remove Gujarati from this list, We do not want to edit Gujarati subtitles, if that changes in future, remove this line
    //languagesSupported = languagesSupported.filter(lang => lang !== 'Gujarati');

    // filter these out and only keep the language that was selected in the main page and English
    return languagesSupported;
}

export function getLanguagesForMainPage() {
    return getLanguageNames(getLanguages(false, false));
}

export function getLanguagesForVideoList() {}

export function getLanguagesForCreateVideo() {
    return getLanguages(false, false);
}

export function SelectLanguageComponent(props) {
    // Extract darkMode and themeVariant from props with defaults
    const { darkMode = false, themeVariant = "vibrant", disabled, languageOptions } = props;
    
    const getInitialLanguages = () => {
        if (
            props.languageOptions === undefined ||
            props.languageOptions.length === 0 ||
            props.languageOptions.length === undefined
        ) {
            return [langOptions[ENGLISH_LANGUAGE_INDEX]];
        } else {
            return langOptions.filter((v) => props.languageOptions.includes(v.label));
        }
    };

    const [languages, setLanguages] = useState(getInitialLanguages);

    //console.log('props for SelectLanguageComponent', props);

    useEffect(() => {
        localStorage.setItem('createVideoLanguages', JSON.stringify(getLanguageNames(languages)));
    }, [languages]);

    const onChange = (newValue, actionMeta) => {
        switch (actionMeta.action) {
            case 'remove-value':
            case 'pop-value':
                if (actionMeta.removedValue.isFixed) {
                    return;
                }
                break;
            case 'clear':
                newValue = langOptions.filter((v) => v.isFixed);
                break;
            default:
                break;
        }
        console.log(newValue);
        // format of each item is { value: 'guj', label: 'Gujarati', isFixed: true }
        localStorage.setItem('createVideoLanguages', JSON.stringify(getLanguageNames(newValue)));
        setLanguages(newValue);
    };

    const disableComponent = props.disabled;
    //console.log('disableComponent', disableComponent);

    const getCustomStyles = (isDarkMode) => ({
        // Keep your existing styles
        multiValue: (base, state) => {
            return state.isFixed ? { ...base, backgroundColor: 'white' } : base;
        },
        multiValueLabel: (base, state) => {
            return state.isFixed ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 } : base;
        },
        multiValueRemove: (base, state) => {
            return state.isFixed ? { ...base, display: 'none' } : base;
        },
        // Add dark mode styles
        control: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d2d2d' : 'white',
            borderColor: isDarkMode ? '#444' : '#ccc',
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d2d2d' : 'white',
            zIndex: 9999, // Ensure the menu is above other elements
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: isDarkMode 
            ? state.isSelected 
                ? '#0078d4' 
                : state.isFocused 
                ? '#3e3e3e' 
                : '#2d2d2d'
            : state.isSelected 
                ? '#0078d4'
                : state.isFocused
                ? '#f0f0f0'
                : 'white',
            color: isDarkMode
            ? state.isSelected
                ? 'white'
                : '#e0e0e0'
            : state.isSelected
                ? 'white'
                : 'black',
        }),
        singleValue: (base) => ({
            ...base,
            color: isDarkMode ? '#e0e0e0' : 'black',
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#444' : '#e8e8e8',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: isDarkMode ? '#e0e0e0' : 'black',
        }),
        input: (base) => ({
            ...base,
            color: isDarkMode ? '#e0e0e0' : 'black',
        }),
        });
    return (
        <Select
            id="selectLanguage"
            value={languages}
            isMulti
            styles={getCustomStyles(darkMode)}
            isClearable={languages.some((v) => !v.isFixed)}
            name="colors"
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={onChange}
            options={langOptions}
            isDisabled={disableComponent}
            
        />
    );
}
